/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetUsersProfileBalanceQueryResponse, GetUsersProfileBalance400 } from "../entities/GetUsersProfileBalance";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getUsersProfileBalance } from "../api/getUsersProfileBalance";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUsersProfileBalanceQueryKey = () => [{ url: '/users/profile/balance' }] as const

export type GetUsersProfileBalanceQueryKey = ReturnType<typeof getUsersProfileBalanceQueryKey>

export function getUsersProfileBalanceQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getUsersProfileBalanceQueryKey()
  return queryOptions<GetUsersProfileBalanceQueryResponse, ResponseErrorConfig<GetUsersProfileBalance400>, GetUsersProfileBalanceQueryResponse, typeof queryKey>({
 
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return getUsersProfileBalance(config)
   },
  })
}

/**
 * @description Получение баланса пользователя
 * @summary Баланс пользователя
 * {@link /users/profile/balance}
 */
export function useGetUsersProfileBalance<TData = GetUsersProfileBalanceQueryResponse, TQueryData = GetUsersProfileBalanceQueryResponse, TQueryKey extends QueryKey = GetUsersProfileBalanceQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<GetUsersProfileBalanceQueryResponse, ResponseErrorConfig<GetUsersProfileBalance400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? getUsersProfileBalanceQueryKey()

  const query = useQuery({
   ...getUsersProfileBalanceQueryOptions(config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetUsersProfileBalance400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}